import { Link, Tooltip, type LinkRouteMapping } from 'components/Blocks';

import { cn } from 'styles';
import { useIsRoute } from 'routes';

import { useAppWrapper } from '../WrapperContext';
import { SideBarIcon, SideBarIconProps } from './Icons';

type ToOptions = LinkRouteMapping[keyof LinkRouteMapping];

type SideLinkProps = ToOptions & {
  label: string;
  icon: SideBarIconProps['icon'];
};

export function SideLink({ icon, label, ...props }: SideLinkProps) {
  const { isSideBarOpen, showMobileSidebar, escapeDrawer } = useAppWrapper();

  const shouldHighlight = useIsRoute(props.to, { matchPrefix: true });

  const showLabel = isSideBarOpen && showMobileSidebar;

  return (
    <Tooltip
      ensurePresence
      position="right"
      arrow
      disabled={showLabel || shouldHighlight}
      content={<span>{label}</span>}
    >
      <Link
        {...props}
        draggable={false}
        onClick={escapeDrawer}
        className={cn(
          'inline-flex items-center gap-4 whitespace-nowrap rounded-lg p-2 font-semibold leading-[1.5] transition-colors small_phone:text-xs',

          showLabel ? 'px-4 py-3' : 'mx-auto justify-between gap-0',

          shouldHighlight
            ? 'bg-primary-foreground text-foreground-title'
            : 'hover:bg-muted-foreground/15',
        )}
      >
        <SideBarIcon icon={icon} color={shouldHighlight ? 'filled' : 'inherit'} />

        <span
          className={cn(
            'transition-opacity duration-300',
            showLabel ? 'opacity-1' : 'w-0 opacity-0',
          )}
        >
          {label}
        </span>
      </Link>
    </Tooltip>
  );
}
